import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import {
  CompanyReadModel,
  SpaceDiscriminator,
  useGetBuildingsByIdManagerQuery,
  usePutSpacesByIdManagerMutation,
} from '@client/api';
import { PageDetailContent } from '@client/toolkit';

import { PageContentAnimation } from '../../../../../components';
import { CompaniesCard } from '../../../components/companies-card/companies-card.component';

export function SpaceCompaniesManagersRoute() {
  const { t: tType } = useTranslation('type');
  const { spaceId } = useParams<{ buildingId: string; spaceId: string; discriminator: SpaceDiscriminator }>();
  const { t: tNotification } = useTranslation('notification');

  const {
    data: manager,
    isFetching,
    refetch,
  } = useGetBuildingsByIdManagerQuery({ id: spaceId ?? '' }, { skip: !spaceId });
  const [putManagers] = usePutSpacesByIdManagerMutation();
  const handleEdit = (data: CompanyReadModel[]) => {
    putManagers({ id: spaceId as string, body: { tenantId: data[0]?.id ?? '' } })
      .unwrap()
      .then(() => {
        refetch();
        toast.success(tNotification('editing.fulfilled'));
      });
  };

  return (
    <PageDetailContent align="left">
      <PageContentAnimation>
        <CompaniesCard
          isLoading={isFetching}
          companies={manager ? [manager] : []}
          role={'Manager'}
          spaceId={spaceId}
          title={tType(`RelationshipType.Manager`, { context: 'plural' })}
          onEdit={handleEdit}
        />
      </PageContentAnimation>
    </PageDetailContent>
  );
}
